import { throttle } from 'throttle-debounce';

export function initHomeReferences(wrapper: HTMLElement) {

	let slider = wrapper.querySelector<HTMLElement>('[data-part="slider"]');
	let next = wrapper.querySelector<HTMLButtonElement>('[data-part="next"]');
	let prev = wrapper.querySelector<HTMLButtonElement>('[data-part="prev"]');

	if (slider && next) {
		next.addEventListener('click', (e) => {
			scrollByStep(slider, 1);
		});
		prev.addEventListener('click', (e) => {
			scrollByStep(slider, -1);
		});
	}

	function adjustDisabledState() {
		let maxScroll = slider.scrollWidth - slider.clientWidth;
		let canScrollLeft = slider.scrollLeft > 0;
		let canScrollRight = slider.scrollLeft < maxScroll;

		if (prev) {
			prev.disabled = !canScrollLeft;
		}
		if (next) {
			next.disabled = !canScrollRight;
		}
	}

	slider.addEventListener('scroll', throttle(250, (e) => {
		adjustDisabledState();
	}));
	adjustDisabledState();

}

function scrollByStep(slider: HTMLElement, step: number) {
	let length = 100;
	let measures = slider.querySelectorAll<HTMLElement>('[data-slide-measure]');
	if (measures.length > 1) {
		let pos1 = measures[0].offsetLeft;
		let pos2 = measures[1].offsetLeft;
		length = pos2 - pos1;
		if (length <= 100) {
			length = 100;
		}
	}
	slider.scrollBy({
		left: length * step,
		behavior: 'smooth',
	});
}
